import {Pipe, PipeTransform} from '@angular/core';
import {FormatGeschaeftsnummerPipe} from "./format-geschaeftsnummer.pipe";
import {TranslateService} from "@ngx-translate/core";
import {TimePointListEntryMeta} from "../../../core/gb-api";
import {FormatGeometergeschaeftsnummerPipe} from './format-geometergeschaeftsnummer.pipe';

@Pipe({
  name: 'formatTimepoint'
})
export class FormatTimepointPipe implements PipeTransform {

  constructor(private translate: TranslateService,
              private geschaeftsnummer: FormatGeschaeftsnummerPipe,
              private formatGeometergeschaeftsnummer: FormatGeometergeschaeftsnummerPipe) {
  }

  transform(timepoint: TimePointListEntryMeta): string {

    if (timepoint == null) {
      return '';
    }

    if (timepoint.type === 'ERSTERFASSUNG_UEBERGEBEN') {
      return this.translate.instant('Ersterfassung');
    }
    if (timepoint.type === "GEO_GESCHAEFT") {
      return timepoint.namePolitischeGemeinde + " " + this.formatGeometergeschaeftsnummer.transform(timepoint.geschaeftsnummer);
    }
    return this.geschaeftsnummer.transform(timepoint.geschaeftsnummer);
  }

}
